module.exports = __webpack_public_path__ + "img/coloring-slider-cloud.7314b924.svg";